import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { isDefined } from '@wm/core';
import {isString, merge} from 'lodash-es';
import {DialogService, PreferenceService, ProjectService} from "@wms/app/services";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public errorLogAnalysisSummary:any;
  public errorLogAnalysisSuggestion:any;
  public preference:any;

  constructor(private toaster: ToastrService, private dialogServer :DialogService, private projectService: ProjectService ,private preferenceService: PreferenceService) {

  }

  public show(type: string, title: string, desc: any, options?: any) {
    // backward compatibility (in 9.x, 4th param is timeout value).
    options = options || {};
    options.timeOut = isDefined(options.timeOut) ? options.timeOut : 2000;
    options.closeButton = true;
    options.positionClass = options.positionClass || 'toast-bottom-right';
    const requestId = desc.headers?.get('x-wm-request-track-id') ?? null;
    // pop the toaster only if either title or description are defined
    if (title || desc) {
      // if the desc is an object, stringify it.
      if (!options.bodyOutputType && typeof(desc) === 'object') {
        desc = JSON.stringify(desc);
      }
      // close the existing toasters before showing up a new toaster.
      this.hide();
      switch (type) {
        case 'success':
          this.toaster.success(desc, title, options);
          break;
        case 'error':
          options.disableTimeOut = true;
          this.preference = this.preferenceService.get()
          if(requestId  && this.preference.workspace.user.analyzeWithAIEnabled){
            options.enableHtml = true;

          let toaster =this.toaster.error(desc+`</br></br><b>(Track ID: ${requestId}) <a class=" copy-link"><i class="  wms wms-content-copy" title="copy"></i></a>  <a class=" analysis-link" title="Ai analysis"><span>Ai</span><i class="wm-icon wms wms-search"></i></a> </b> `, title,options);
          toaster.onShown.subscribe(()=>{
            const copylink = document.querySelector(`.copy-link`);
            if (copylink) {
              copylink.addEventListener('click', (event) => {
                event.preventDefault();
                navigator.clipboard.writeText(requestId).then(() => {});
              });
            }

            const link = document.querySelector(`.analysis-link`);
            if (link) {
              link.addEventListener('click', (event) => {
                event.preventDefault();
                  this.projectService.getLogAnalysisRepost(requestId).then((response) => {
                    this.errorLogAnalysisSuggestion = response.result?.fix_suggestion
                    this.errorLogAnalysisSummary = response.result?.summary
                    this.dialogServer.open('errorAnalysisDialogue');
                  });

              });
            }
          })
          }else {
            this.toaster.error(desc,title, options);
          }

          break;
        case 'info':
          this.toaster.info(desc,title, options);
          break;
        case 'warning':
          this.toaster.warning(desc, title, options);
          break;
      }
    }
  }

  public hide(){
    this.toaster.clear();
  }

}
